import { Component } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { PopoverModule } from 'primeng/popover';

@Component({
    selector: 'ef-errors-sidenav-wrapper',
    standalone: true,
    template: `
        <ef-errors-sidenav></ef-errors-sidenav>
    `,
    imports: [SharedModule] // Add any necessary imports here
})
export class ErrorsSidenavWrapperComponent {}
